<template>
  <CContainer>
    <CRow class="justify-content-center">
      <Loader :is-processing="state.isLoading" />
      <CCol md="12" class="text-start">
        <CRow>
          <CCol class="d-flex">
            <div class="v3-module-list-title" role="heading" aria-level="2">
              Logout Overnight
            </div>

            <HelpCenterButton
              classes="ms-2"
              content-key="module_logout_overnight"
            />
          </CCol>
        </CRow>
        <p class="v3-module-list-box m-0">
          Enabling this module will log users out overnight, and force them to
          log in each day
        </p>
        <CRow>
          <div>
            <div class="v3-module-list-checkbox d-flex ms-3 mb-3">
              <CustomCheck
                :model-value="state.form.enableForStudents"
                label="For Students Only"
                @change="toggleStudents"
              ></CustomCheck>
            </div>
            <div class="v3-module-list-checkbox d-flex ms-3 mb-3">
              <CustomCheck
                :model-value="state.form.enableForTeachersStaff"
                label="For Teachers/Staff Only"
                @change="toggleTeachersStaff"
              ></CustomCheck>
            </div>

            <div class="v3-module-list-checkbox d-flex ms-3 mb-3">
              <CustomCheck
                :model-value="state.form.enableForAdmins"
                label="For Admins Only"
                @change="toggleAdmins"
              ></CustomCheck>
            </div>
          </div>
        </CRow>

        <CAlert
          v-if="state.response.message"
          dismissible
          class="mt-4"
          :color="state.response.type"
          :show="!!state.response.message"
          role="status"
          :keep-short="true"
          aria-live="polite"
          @close="resetResponse"
        >
          {{ state.response.message }}
        </CAlert>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import HelpCenterButton from "../../HelpCenterButton.vue"
import CustomCheck from "@/v3components/shared/Form/CustomCheck.vue"
import { useStore } from "vuex"
import { onMounted, computed, reactive } from "vue"
import Loader from "@/v3components/shared/Loader/Loader.vue"
export default {
  name: "LogoutOvernightModuleForm",
  components: { HelpCenterButton, Loader, CustomCheck },
  setup() {
    const store = useStore()

    const state = reactive({
      form: {
        enableForStudents: false,
        enableForTeachersStaff: false,
        enableForAdmins: false
      },
      isLoading: false,
      response: {
        type: "",
        message: "",
        errors: {}
      }
    })

    const options = computed(() => {
      const logoutOvernightModule =
        store.state.schools.activeSchoolModules?.find(
          (module) => module.id === 10
        )
      if (!logoutOvernightModule?.pivot?.option_json) return null
      try {
        return JSON.parse(logoutOvernightModule.pivot.option_json)
      } catch {
        return null
      }
    })

    onMounted(() => {
      if (options.value) {
        setForm()
      }
    })

    const setForm = () => {
      state.form.enableForStudents = Boolean(options.value?.students)
      state.form.enableForTeachersStaff = Boolean(
        options.value?.["teachers-staff"]
      )
      state.form.enableForAdmins = Boolean(options.value?.admins)
    }
    const resetResponse = () => {
      state.response = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const setSuccessResponse = (message) => {
      state.response = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.response = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }
    const toggleStudents = (value) => {
      state.form.enableForStudents = value
      toggleLogoutOvernight()
    }
    const toggleTeachersStaff = (value) => {
      state.form.enableForTeachersStaff = value
      toggleLogoutOvernight()
    }
    const toggleAdmins = (value) => {
      state.form.enableForAdmins = value
      toggleLogoutOvernight()
    }
    const toggleLogoutOvernight = () => {
      const options = {
        students: state.form.enableForStudents,
        "teachers-staff": state.form.enableForTeachersStaff,
        admins: state.form.enableForAdmins
      }
      const inputsData = JSON.stringify(options)
      state.isLoading = true
      resetResponse()
      store
        .dispatch("modules/updateLogoutOvernightModule", {
          id: 10,
          option_json: inputsData
        })
        .then(() => {
          state.isLoading = false
          setSuccessResponse("Module updated.")
          store.dispatch("schools/getActiveModules", {
            clearCacheEntry: true
          })
        })
        .catch((error) => {
          const response = error.response ? error.response.data : {}
          setErrorResponse(response.message, response.errors)
        })
        .finally(() => {
          state.isLoading = false
        })
    }

    return {
      state,
      toggleLogoutOvernight,
      toggleStudents,
      toggleTeachersStaff,
      toggleAdmins
    }
  }
}
</script>
